import React from "react"
import "./NursingNotesPrint.scss"
import RenderSummaryHeader from "components/SummaryView/components/RenderSummaryHeader/RenderSummaryHeader"
import { convertToDateString, convertToTimeString } from "core/utils/date"


function NursingNotesPrint({
  componentRef, patientDetail, smartSummaryData, treatments, vitals, servicesRendered, nurseNotes, completedBy
}: any) {

  return (
    <div className="nurse-notes-print-wrapper" ref={componentRef}>
      {/* Patient Summary */}
      <div className="nursing-section mb-3">
        <RenderSummaryHeader patientDetail={patientDetail} smartSummaryData={smartSummaryData} />
      </div>

      {/* Treatment Plan */}
      <div className="nursing-section">
        <div className="heading">Treatment Plan</div>
        <div className="details">
          <table className="table">
            <thead>
              <tr>
                <th>Treatment Order</th>
                <th>Medicine Administaration</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Others</th>
              </tr>
            </thead>
            <tbody>
              {treatments?.map((treatment: any, index: number) => {
                return (
                  <tr key={`treatment-plan-${index}`}>
                    <td>{treatment?.treatmentOrder}</td>
                    <td>{treatment?.medicineAdministration}</td>
                    <td>{convertToTimeString(treatment?.timeStartTreatment)}</td>
                    <td>{convertToTimeString(treatment?.timeFinishTreatment)}</td>
                    <td>{treatment?.others}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Vitals */}
      <div className="nursing-section">
        <div className="heading">Vitals</div>
        <div className="details">
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Temperature</th>
                <th>BP Systolic</th>
                <th>BP Diastolic</th>
                <th>Pulse</th>
                <th>SPO2</th>
                <th>Resp</th>
              </tr>
            </thead>
            <tbody>
              {vitals?.map((vital: any, index: number) => {
                return (
                  <tr key={`vital-${index}`}>
                    <td>{convertToDateString(vital?.vitalCaptureDate)}</td>
                    <td>{convertToTimeString(vital?.height)}</td>
                    <td>{vital?.temperature}</td>
                    <td>{vital?.bpSystolic}</td>
                    <td>{vital?.bpDiastolic}</td>
                    <td>{vital?.pulseInfo}</td>
                    <td>{vital?.spo2}</td>
                    <td>{vital?.respirationRate}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Nursing Notes */}
      <div className="nursing-section">
        <div className="heading">Nursing Notes</div>
        <div className="details">
          <div className="textarea-content">
            {nurseNotes}
          </div>
        </div>
      </div>

      {/* Services Rendered */}
      <div className="nursing-section">
        <div className="heading">Services Rendered</div>
        <div className="details">
          <table className="table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Medicine</th>
              </tr>
            </thead>
            <tbody>
              {servicesRendered?.map((service: any, index: number) => {
                return (
                  <tr key={`service-${index}`}>
                    <td>{service?.serviceTemplateName}</td>
                    <td>{service?.medicine?.map((med: string) => med).join(', ')}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Completed By */}
      <div className="nursing-section">
        <div className="heading">Completed By</div>
        <div className="details">{completedBy}</div>
      </div>
    </div>
  )
}

export default NursingNotesPrint
